import { render } from "./LesOrganisationsPage.vue?vue&type=template&id=b999d3b2"
import script from "./LesOrganisationsPage.vue?vue&type=script&lang=js"
export * from "./LesOrganisationsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__